import type { ExportRequest } from '@nowline/preview-shell';

function derivedBase(source: string): string {
    const match = /roadmap\s+"([^"]+)"/.exec(source);
    if (!match?.[1]) return 'nowline-diagram';
    return match[1].replace(/[^a-z0-9-_]/gi, '-').toLowerCase();
}

function triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 0);
}

/**
 * Trigger a download for a Save SVG / Save PNG request from the preview shell.
 * The shell handles rasterization; this function just blobs the bytes and names the file.
 */
export function downloadExport(req: ExportRequest, source: string): void {
    const base = derivedBase(source);
    if (req.format === 'svg') {
        const blob = new Blob([req.body as string], { type: 'image/svg+xml' });
        triggerDownload(blob, `${base}.svg`);
    } else {
        // new Uint8Array(source) normalises Uint8Array<ArrayBufferLike> → Uint8Array<ArrayBuffer>
        const blob = new Blob([new Uint8Array(req.body as Uint8Array)], { type: 'image/png' });
        triggerDownload(blob, `${base}.png`);
    }
}

/** Download the raw .nowline source text. */
export function downloadSource(source: string): void {
    const base = derivedBase(source);
    const blob = new Blob([source], { type: 'text/plain' });
    triggerDownload(blob, `${base}.nowline`);
}
